module.exports = __webpack_public_path__ + "static/media/ref.87759264.png";